import { render } from "./OrderOutboxQueueListTableHeader.vue?vue&type=template&id=685b2729"
import script from "./OrderOutboxQueueListTableHeader.vue?vue&type=script&lang=js"
export * from "./OrderOutboxQueueListTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__